// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3ehz0","content":"style_content__3eJ6I","logo":"style_logo__203YL","back":"style_back__q7Sc5"};